import React from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const YonotsuneHelpOverlay = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="choice-prompt-overlay flavor-modal-overlay" style={{ zIndex: 3100 }} onClick={onClose}>
      <div className="choice-prompt flavor-modal" style={{ maxWidth: '600px' }} onClick={e => e.stopPropagation()}>
        <div className="flavor-header">
          <span className="flavor-icon">📖</span>
          <h3>{getUILoc('YONOTSUNE_HELP.TITLE') || '【「世の常」の進め方】'}</h3>
        </div>
        <div className="flavor-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <p className="flavor-text">
            {getUILoc('YONOTSUNE_HELP.BODY')}
          </p>
        </div>
        <div className="choice-options" style={{ marginTop: '20px', justifyContent: 'center' }}>
          <button className="yonotsune-btn" onClick={onClose}>
            {getUILoc('BUTTONS.CLOSE')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default YonotsuneHelpOverlay;
